import { gstConstants } from '../_constants';

const initialState = {
  accounts: [],
  errors: {}
};


export function gst(state = initialState, action) {
  switch (action.type) {

  case gstConstants.G_S_T_ACCOUNTS_LOADED:
    return Object.assign({}, state, { accounts: action.data.results });

  case gstConstants.G_S_T_ACCOUNT_LOADED:
    return Object.assign({}, state, { account: action.data });

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/gst.reducer.js